export const DEFAULT = {
  RADIUS: 10,
  RADIUS_MIN: 2,
  RADIUS_MAX: 20,
};
